import { render, staticRenderFns } from "./changeDb.vue?vue&type=template&id=c1beafb4&scoped=true&"
import script from "./changeDb.vue?vue&type=script&lang=js&"
export * from "./changeDb.vue?vue&type=script&lang=js&"
import style0 from "./changeDb.vue?vue&type=style&index=0&id=c1beafb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1beafb4",
  null
  
)

export default component.exports